import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import axios from 'axios'
import global from '@/assets/js/global.js'
import filter from '@/assets/js/filter.js'

// createApp(App).use(store).use(router).mount('#app')
const app = createApp(App);
// app.use(store);
app.use(router);
app.use(global);
app.use(filter);
app.config.globalProperties.$axios = axios;
app.mount('#app');
